import React, { useState } from "react";
import { Button, Modal, Spinner } from "react-bootstrap";
import Select from "react-select";
import { useForm, Controller } from "react-hook-form";
import { API_URL, statusPenggunaOptions, useAxios } from "../../../utils/const.js";
import { Message } from "primereact/message";
import { useToast } from "../../../Context/ToastContext.js";

const UpdateModal = ({ toggleModal, getUsers, user, roles }) => {

  const axiosInstance = useAxios();
  const { setToastObj } = useToast();

  const {
    register,
    handleSubmit,
    control,
    formState: { errors }
  } = useForm({
    defaultValues: {
      nim: user.nim,
      name: user.name,
      email: user.email,
      role: {
        value: user.userHasRoles.length > 0 ? user.userHasRoles[0].role_id : 0,
        label: user.userHasRoles.length > 0 ? user.userHasRoles[0].roles.name : "-- PILIH SALAH SATU --",
      },
      status: {
        value: user.status,
        label: user.status === 1 ? "AKTIF" : "TIDAK AKTIF",
      },
    },
  });

  const [loading, setLoading] = useState(false);

  const closeModal = () => {
    toggleModal(false);
  };

  const handleSave = async (formData) => {
    setLoading(true);
    try {
      await axiosInstance.put(`${API_URL}/users/${user.id}`, {
        nim: formData.nim,
        name: formData.name,
        email: formData.email,
        roles: formData.role.value,
        status: formData.status.value,
      });
      getUsers();
      setLoading(false);
      setToastObj({ msg: "Data Berhasil diubah", type: "success" });


      closeModal();
    } catch (error) {
      let errorMessage = "Terjadi kesalahan";
      if (error.response.data.msg != undefined) {
        errorMessage = `Terjadi kesalahan, ${error.response.data.msg}`;
      } else {
        errorMessage = error.message;
      }
      setLoading(false);
      setToastObj({
        msg: errorMessage,
        type: "danger",
      });
      closeModal();
    }
  };

  const roleOptions = roles.map((item) => ({
    value: item.id,
    label: item.name
  }));

  return (
    <Modal show={toggleModal} size="lg">
      <Modal.Header>
        <Modal.Title>
          <h6>Ubah Pengguna</h6>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row mb-3">
          <div className="col-md-4">
            <div className="form-group">
              <label className="form-label">NIDN/NIM</label>
              <input
                {...register("nim", {
                  required: "NIM tidak boleh kosong!",
                  minLength: {
                    value: 2,
                    message: "NIM minimal 2 karakter",
                  },
                  maxLength: {
                    value: 32,
                    message: "NIM maximal 32 karakter",
                  },
                })}
                placeholder="Ex. 030001700001"
                type="text"
                className="form-control"
              />
              {errors.nim && (
                <div className="">
                  <Message
                    className="mt-2 d-flex"
                    severity="error"
                    text={errors.nim.message}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-md-4">
            <div className="form-group">
              <label className="form-label">Nama</label>
              <input
                {...register("name", {
                  required: "Nama tidak boleh kosong!",
                  minLength: {
                    value: 2,
                    message: "Nama minimal 2 karakter",
                  },
                  maxLength: {
                    value: 60,
                    message: "Nama maximal 60 karakter",
                  },
                })}
                placeholder="Ex. Nama Pengguna"
                type="text"
                className="form-control"
              />
              {errors.name && (
                <div className="">
                  <Message
                    className="mt-2 d-flex"
                    severity="error"
                    text={errors.name.message}
                  />
                </div>
              )}
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label className="form-label">Email</label>
              <input
                {...register("email", {
                  required: "Email tidak boleh kosong!",
                  minLength: {
                    value: 2,
                    message: "Email minimal 2 karakter",
                  },
                  maxLength: {
                    value: 60,
                    message: "Email maximal 60 karakter",
                  },
                  pattern: {
                    value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                    message: "Email tidak valid",
                  },
                })}
                placeholder="Ex. example@example.com"
                type="text"
                className="form-control"
              />
              {errors.email && (
                <div className="">
                  <Message
                    className="mt-2 d-flex"
                    severity="error"
                    text={errors.email.message}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-md-4">
            <div className="form-group">
              <label className="form-label">Role</label>
              <Controller
                control={control}
                name="role"
                rules={{ required: "Pilih salah satu" }}
                render={({ field }) => (
                  <Select
                    value={field.value}
                    options={roleOptions}
                    onChange={(value) => field.onChange(value)}
                  />
                )}
              />
              {errors.role && (
                <div className="">
                  <Message
                    className="mt-2 d-flex"
                    severity="error"
                    text={errors.role.message}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-md-4">
            <div className="form-group">
              <label className="form-label">Status</label>
              <Controller
                control={control}
                name="status"
                rules={{ required: "Pilih salah satu" }}
                render={({ field }) => (
                  <Select
                    value={field.value}
                    options={statusPenggunaOptions}
                    onChange={(value) => field.onChange(value)}
                  />
                )}
              />
              {errors.status && (
                <div className="">
                  <Message
                    className="mt-2 d-flex"
                    severity="error"
                    text={errors.status.message}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={closeModal}>
          Batal
        </Button>
        <Button
          variant="success"
          disabled={loading}
          onClick={handleSubmit(handleSave)}
        >
          {loading && (
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
            />
          )}
          <span className="ml-1">Simpan</span>
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default UpdateModal;
